<mat-form-field appearance="outline" class="w-100">
  <mat-label
    >{{ label }}
    <span class="count-lbl">({{ totalCount || 0 }})</span></mat-label
  >
  <mat-select
    [(ngModel)]="selectedValue"
    (ngModelChange)="onValueChange($event)"
  >
    @for (option of options; track option) {
      <mat-option [value]="option.id">
        {{ option.name }}
        <span class="count-lbl">({{ option.count || 0 }})</span>
      </mat-option>
    }
  </mat-select>
  @if (selectedValue?.length) {
    <button
      mat-icon-button
      matSuffix
      color="primary"
      (click)="
        onClearFilter(); $event.preventDefault(); $event.stopPropagation()
      "
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>
